var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiktok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62.505,
    height: 62.505,
    viewBox: "0 0 62.505 62.505",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2082",
    "data-name": "Rectangle 2082",
    width: 31.491,
    height: 36.034
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2598",
    "data-name": "Groupe 2598",
    transform: "translate(-1211.5 -730.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2461",
    "data-name": "Groupe 2461",
    transform: "translate(428.926 20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2904",
    "data-name": "Trac\\xE9 2904",
    d: "M61.5,30.753A30.752,30.752,0,1,1,30.753,0,30.752,30.752,0,0,1,61.5,30.753",
    transform: "translate(783.074 710.999)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2470",
    "data-name": "Groupe 2470",
    transform: "translate(798.081 722.789)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2469",
    "data-name": "Groupe 2469",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2938",
    "data-name": "Trac\\xE9 2938",
    d: "M29.689,8.539a7.316,7.316,0,0,1-4.465-2.585A8.6,8.6,0,0,1,22.952,0H16.764V24.676a5.266,5.266,0,0,1-5.327,5.248,5.454,5.454,0,0,1-4.308-2.193,5.292,5.292,0,0,1,4.308-8.3A5.049,5.049,0,0,1,13,19.662V13.4a9.634,9.634,0,0,0-1.567-.157H11.2A11.42,11.42,0,0,0,3.055,32.431a11.654,11.654,0,0,0,8.382,3.6A11.451,11.451,0,0,0,22.952,24.676V11.829a11.406,11.406,0,0,0,8.539,2.9V8.539a3.507,3.507,0,0,1-1.8,0",
    fillRule: "evenodd"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.a087f0621a18871566943f58a8288a31.svg";
export { ForwardRef as ReactComponent };